import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-eat-table',
  templateUrl: './eat-table.component.html',
  styleUrls: ['./eat-table.component.css']
})
export class EatTableComponent implements OnInit {


  @Input('sheetData') sheetData: any;
  @Input('headerses') headerses: any;
  @Output() loadEditData = new EventEmitter();
  @Output() loadFirstData = new EventEmitter();

  
  constructor() { }

  ngOnInit() {
    console.log("Headerses", this.headerses);

  }

  sendEditData(request) {
    this.loadEditData.emit(request);
  }

  sendFirstData(request) {
    this.loadFirstData.emit(request);
  }

}
